import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  button: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    padding: 0px !important;
  `,
  menuItem: css`
    padding: 0px !important;
    width: 100%;
  `,
  optionMenu: css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    padding: 8px 16px 8px;
  `,
  activeOption: css`
    @media (max-width: 480px) {
      white-space: nowrap;
      max-width: 198px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `,
  popper: css`
    min-width: 262px;
    margin-top: 6px !important;
  `,
  buttonWrapper: css`
    display: flex;
    flex-direction: row;
    gap: 8px;
  `,
  userInfo: css`
    gap: 8px;
    cursor: pointer;
    text-align: left;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  `,
  parentOption: css`
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 0px 16px 8px;
    width: 100%;
    border-bottom: 1px solid ${colors.platinum};
  `,
  otherAccountLabel: css`
    padding: 16px 16px 0px;
  `,
};

export default styles;
